import React from 'react';

import Section from '../basic/layouts/Section';
import ThreeCardList from '../cards/ThreeCardList';
import Text from '../basic/Text';
 
const ThreeCardSection = ({ cards }) => {
    return (
        <Section>
            <Text component="h2" color="black" className="title" textAlign="center">
                You might also like
            </Text>
            <ThreeCardList cards={cards} />
        </Section>
    )
}
 
export default ThreeCardSection;